<template>
    <form class="access-token-form form-horizontal" @submit.prevent="submit()">

    <div class="col-sm-12">
        <div class="form-group" :class="{ 'has-error': errors['institution_id'] }">
            <label for="institution_id" class="control-label">Institución</label>
            <institution-select id="institution_id" v-model="data.institution_id"  :institutions="this.institutions"></institution-select>
            <div class="help-block" v-for="e in errors['institution_id']"  >El campo institución es obligatorio.</div>
        </div>
    </div>
    <hr>
    <h3>Contacto Administrativo / Técnico</h3>
    <div class="alert alert-secondary">
        Corresponde a la persona encargada de administrar la integración y de cumplir el rol de contraparte técnica de la plataforma que integrará la API de ChileAtiende. <u>El resguardo de las credenciales de integragación son responsabilidad de la institución,</u> se recomienda que el contacto técnico sea un funcionario.
    </div>

    <div class="col-sm-12">
        <div class="form-group" :class="{ 'has-error': errors['nombreCompleto'] }">
            <label for="nombreCompleto">Nombre Completo</label>
            <input type="text" class="form-control" id="nombreCompleto" v-model="data.nombreCompleto">
            <div class="help-block" v-for="e in errors['nombreCompleto']">{{e}}</div>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="form-group" :class="{ 'has-error': errors['email'] }">
            <label for="email">Correo Electrónico</label>
            <input type="email" class="form-control" id="email" v-model="data.email" placeholder="ejemplo@mail.com">
            <div class="help-block" v-for="e in errors['email']">{{e}}</div>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="form-group" :class="{ 'has-error': errors['telefono'] }">
            <label for="telefono">Teléfono (Formato +56XXXXXXXXX)</label>
            <input type="text" class="form-control" id="telefono" v-model="data.telefono" maxlength="12">
            <div class="help-block" v-for="e in errors['telefono']">{{e}}</div>
        </div>
    </div>
    
    <hr>
    <h3>Antecedentes Integración</h3>
    <div class="alert alert-secondary">
        <b>Nombre de la Aplicación</b>: Corresponde al nombre del aplicativo en donde se integrará el API de ChileAtiende, Identifique claramente a la institución y a la plataforma integrada.
        <br><br>
        <b>Descripción</b>: Indique el propósito de la integración, incluyendo cualquier información que considere relevante, por ejemplo si el desarrollo estará a cargo de un proveedor externo. La descripción debe ser concisa.
        <br><br>
        <b>URL de la Plataforma</b>: Indica la dirección pública con la que se accede al sitio web donde se implementará la integración.
        <br><br>
        <b>Recursos a implementar</b>: Indique que métodos de la API ChileAtiende pretende utilizar. Ejemplo fichas - Sucursales - Instituciones.
    </div>

    <div class="col-sm-12">
        <div class="form-group" :class="{ 'has-error': errors['nombreAplicacion'] }">
            <label for="nombreAplicacion">Nombre de la Aplicación</label>
            <input type="text" class="form-control" id="nombreAplicacion" v-model="data.nombreAplicacion">
            <div class="help-block" v-for="e in errors['nombreAplicacion']">{{e}}</div>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="form-group" :class="{ 'has-error': errors['descripcion'] }">
            <label for="descripcion">Descripción</label>
              <textarea class="form-control" name="descripcion" id="descripcion" rows="3" v-model="data.descripcion"></textarea>
              <div class="help-block" v-for="e in errors['descripcion']">{{e}}</div>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="form-group" :class="{ 'has-error': errors['resources'] }">
            <label for="resources">Recursos / métodos a implementar</label>
            <input type="text" class="form-control" id="resources" v-model="data.resources">
            <div class="help-block" v-for="e in errors['resources']">{{e}}</div>
        </div>
    </div>
    <div class="col-sm-12">
        <div class="form-group" :class="{ 'has-error': errors['url'] }">
            <label for="url">URL de la página de la aplicación donde se implementará el sistema (opcional)</label>
            <input type="text" class="form-control" id="url" v-model="data.url" placeholder="https://dominio.com">
            <div class="help-block" v-for="e in errors['url']">{{e}}</div>
        </div>
    </div>
    <br>
    <!-- Termina el nuevo formulario -->
        <div class="form-group">
            <!-- <div class="col-sm-offset-2 col-sm-10"> -->
            <div class="col-sm-12">
                <a class="btn btn-default" href="desarrolladores">Cancelar</a>
                <button type="submit" class="btn btn-primary" :disabled="isDisable">Enviar Solicitud</button>
            </div>
        </div>

    </form>
</template>
<style lang="scss" scoped>
    h3 {
        font-size: 1.42275rem;
    }
    .el-select {
        display: block !important;
    }
    .alert {
        position: relative;
        margin-bottom: 1rem;
        border: 1px solid transparent;
        border-radius: 0.35rem;
    }
    .alert-secondary {
        color: #3c4657;
        background-color: #e2e3e5;
        border-color: #d6d8db;
    }
</style>
<script>
    import ElSwitch from 'element-ui/lib/switch';
    import InstitutionSelect from './InstitutionSelect.vue';
    import CategoriesSelect from './CategoriesSelect.vue';

    export default {
        data: function(){
            return{
                data: {
                    institution_id: '',
                    nombreCompleto: '',
                    email: '',
                    telefono: '',
                    descripcion: '',
                    nombreAplicacion: '',
                    resources: '',
                    url: '',
                },
                isDisable: false,
                errors: {}
            }
        },
        components: {
            InstitutionSelect,
        },
        props: ['institutions'],
        computed:{
            validateForm:function(){
                this.errors = {};

                let testEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.data.email)
                let testTlf = /^([+,0-9])*$/.test(this.data.telefono)

                let institution_id      = this.data.institution_id === '' || this.data.institution_id === null;
                let nombreCompleto      = this.data.nombreCompleto === '' || this.data.nombreCompleto === null;
                let email               = this.data.email === '' || this.data.email === null || !testEmail;
                let telefono            = this.data.telefono === '' || this.data.telefono === null || this.data.telefono.length < 12 || !testTlf;
                let descripcion         = this.data.descripcion === '' || this.data.descripcion === null;
                let nombreAplicacion    = this.data.nombreAplicacion === '' || this.data.nombreAplicacion === null;
                let resources           = this.data.resources === '' || this.data.resources === null;
                let url                 = this.data.url === '' ? true : /^((ftp|http|https):\/\/)([A-z]+)\.([A-z]{2,})/.test(this.data.url);
                let errores ={};
                

                if(institution_id)
                    errores['institution_id']   = ['El campo Institución no puede estar vacío.'];
                
                if(nombreCompleto)
                    errores['nombreCompleto']   = ['El campo Nombre no puede estar vacío.'];
                
                if(email)
                    errores['email']            = ['El campo Email no puede ser vacío o no cumple con los requisitos para ser un email.'];

                if(telefono)
                    errores['telefono']         = ['El campo Telefono no pude estar vacío, ser menor a 12 caracteres, o contener caracteres alfabeticos.'];

                if(descripcion)
                    errores['descripcion']      = ['El campo Descripción no puede estar vacío.'];
                
                if(nombreAplicacion)
                    errores['nombreAplicacion'] = ['El campo Nombre de la Aplicación no puede estar vacío.'];

                if(resources)
                    errores['resources']        = ['El campo Recursos o métodos a implementar de la Aplicación no puede estar vacío.'];

                if(!url)
                    errores['url']              = ['El campo URL de la Aplicación no cumple con los requisitos.'];

                if(institution_id || nombreCompleto || email || telefono || descripcion || nombreAplicacion || resources || !url){
                    this.errors     = errores;
                    this.isDisable  = true;
                    return true;
                }
                else
                    this.isDisable = false;
                    return false;
            }
        },
        methods:{
            submit: function(){
                var self = this;
                self.isDisable = true;

                if (self.validateForm) {
                    self.$message.error('Revise los errores en el formulario antes de continuar.');
                } else {
                    axios({
                        url: 'desarrolladores/access_token',
                        method: 'POST',
                        data: self.data,
                    }).then(function(response){
                        window.location.replace(response.data.redirect);
                    }).catch(function(error){
                        console.log(error);
                        self.errors = error.response.data.errors;
                    });
                }
            }
        }
    }
</script>